import * as types from './types'

export default {
  [types.SET_TESTDRIVE_ID](state, data) {
    state.testdrive = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/testdrive/mutations.js